<template>
  <div v-if="show" class="upload_notice">
    <div v-if="state == 'processing'" class="section-processing">
      <div class="spinner"></div>
      <p>
        We are processing the {{type}} file.
      </p>
      <p> Please check back later to
        <span v-if="type == 'audio'">hear</span>
        <span v-else>view</span>
        it.
      </p>
    </div>
    <div v-else-if="state == 'failed'" class="section-processing__failed">
      <p>
        <span class="red">Processing failed.</span>
        <br />
        Please try again. You may want to use another format.
      </p>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    show: {
      type: Boolean
    },
    state: {
      type: String
    },
    type: {
      type: String
    }
  }
}
</script>
